module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-about",
    class: [{
      'is-alt': _vm.isAlt
    }],
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subheader', {
    attrs: {
      "title": _vm.paragraph.title
    }
  }), _vm._v(" "), _c('div-container', [(_vm.imageUrl) ? _c('div-columns', {
    staticClass: "is-hidden-desktop"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column is-5 has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": _vm.imageLink,
      "target": "_blank"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticStyle: {
      "width": "300px",
      "padding": "30px"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "300"
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div-columns', {
    class: {
      'with-image': _vm.imageUrl !== undefined
    },
    attrs: {
      "paddingTop": "0.5em"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.imageLink,
      "target": "_blank"
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "is-hidden-touch",
    staticStyle: {
      "width": "300px",
      "padding": "50px",
      "float": "left"
    },
    attrs: {
      "src": _vm.imageUrl,
      "width": "300"
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.paragraph.content)
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de0f5f22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AboutSubSection.vue
// module id = 939
// module chunks = 1